<template>
  <div class="page-main">
    <van-nav-bar
      class="nav-bar"
      fixed
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />    
    <div class="content">
      <van-tabs v-model="active" sticky @click="handleTabs">
        <van-tab title="关注"></van-tab>
        <van-tab title="粉丝"></van-tab>
      </van-tabs> 
      <MdScroll id="follow" v-show="active === 0" :url="follow.url" :filterData="follow.filterData" @getList="getFollowList">
        <Follow :list="follow.list" @onChange="onChangeFollow"></Follow>
      </MdScroll>
      <MdScroll id="fans" v-show="active === 1" :url="fans.url" :filterData="fans.filterData" @getList="getfansList">
        <Fans :list="fans.list" @onChange="onChangeFans"></Fans>
      </MdScroll>
    </div>   
  </div>
</template>

<script>
import MdScroll from '@/components/mdScroll/mdScroll'
import commonMix from '@/mixins/commonMix'
import Follow from './follow'
import Fans from './fans'
import { Cms } from '@/api'
export default {
  name: 'fans',
  components: { Follow, Fans, MdScroll },
  mixins: [commonMix],
  data() {
    return {
      active: 0,
      follow: {
        list: [],
        url: Cms.FollowQueryFollowUserByPage,
        filterData: {
          UserId: this.$mdUtils.getUserInfo('Id'),
          PageIndex: 1,
          PageSize: 10
        }
      },
      fans: {
        list: [],
        url: this.$mdUtils.getUserInfo('Type') === 1 ? Cms.FollowQueryFanByPage : Cms.FollowQueryFollowedUserByPage,
        filterData: {
          UserId: this.$mdUtils.getUserInfo('Id'),
          PageIndex: 1,
          PageSize: 10
        }
      },
      fansList: []
    }
  },
  watch: {
    $route: {
      handler() {
        this.handleNav(this.$route.params.title)
      },
      immediate: true
    }
  },
  methods: {
    onChangeFans(row) {
      let tag = this.follow.list.find(item => item.UserId === row.UserId)
      if (tag) {
        tag.Author.FollowedQuantity = row.Author.FollowedQuantity
        tag.isFollow = row.isFollow
      }
    },
    onChangeFollow(row) {
      let tag = this.fans.list.find(item => item.UserId === row.UserId)
      if (tag) {
        tag.Author.FollowedQuantity = row.Author.FollowedQuantity
        tag.isFollow = row.isFollow
        tag.isBoth = row.isFollow
      }
    },
    getFollowList(list) {
      this.follow.list = list.map(item => {
        item.isFollow = true
        return {
          Author: {
            Id: item.UserId,
            Type: item.UserType,
            ...item
          },
          ...item
        }
      })
    },
    getfansList(list) {
      this.fans.list = list.map(item => {
        item.isFollow = item.Both
        item.isBoth = item.Both
        return {
          Author: {
            Id: item.UserId,
            Type: item.UserType,
            ...item
          },
          ...item
        }
      })
    },
    handleNav(title) {
      switch (title) {
        case 'follow':
          this.active = 0
          break
        case 'fans':
          this.active = 1
          break

        default:
          break
      }
    },
    handleTabs(i) {
      switch (i) {
        case 0:
          this.$router.replace({ name: 'fans', params: { title: 'follow' } })
          break
        case 1:
          this.$router.replace({ name: 'fans', params: { title: 'fans' } })
          break

        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  min-height: 46px;
}
.content {
  position: fixed;
  left: 0;
  right: 0;
  top: 46px;
  bottom: 0;
}
</style>

